
import { 	increasepricePage } from "@/api/order/payment"
export default {
  name: "purchased",
  components: {},
  data: () => {
    return {
      purchasedList:[], //加價購商品list
      loading: true
    };
  },
  created() {
    this.getList();
  },
  methods: {
    addToCart(item) {
			this.$store .dispatch("cart/add_to_cart", {
				site_id: item.site_id,
				sku_id: item.sku_id,
				num: 1
			})
			.then(res => {
				var data = res.data
				if (data > 0) {
					this.$message({
						message: "加入購物車成功",
						type: "success"
					})
				}
			})
		},
    getList() {
			increasepricePage({site_id:this.$route.query.siteId,page:1,page_size:999}).then(res => {
				this.purchasedList=res.data.list
        this.loading = false;
			}).catch(err => {
        this.loading = false;
        this.$message.error(err.message);
      });
    },
  }
};
